document.querySelector(".mobile-menu__button").addEventListener("click", () => {
  // click the first-level item immediately
  const el1 = document.querySelector(".mobile-menu__item--level-1:first-child .mobile-nav__trigger--level-1");
  if (el1) el1.click();
});

document.querySelector(".mobile-menu__button").addEventListener("click", () => {
  setTimeout(() => {
      const el2 = document.querySelector(
        ".mobile-menu__item--level-1:first-child .mobile-menu__item--level-2:first-child .mobile-nav__trigger--level-2"
      );
      if (el2) el2.click();
  }, 700); // adjust delay if needed
});




// Script for nav item font update to cursive
const updateNavItemFont = () => {
  const header = document.querySelector('header');
  const mobileMenu = document.querySelector('mobile-menu');
  const headerDataTargets = [...new Set(header.getAttribute('data-item-target').split(',').concat(mobileMenu.getAttribute('data-item-target').split(',')))];
  const navTexts = document.querySelectorAll('.navtext, .mobile-navlink');

  navTexts.forEach(navText => {
    let currentHTML = navText.innerHTML;

    // Wrap "Retailer Exclusive!" — run BEFORE the cursive-font loop
    // so injected spans don't break the literal match.
    currentHTML = currentHTML.replace(
      'Retailer Exclusive!',
      '<span class="cursive-font">Retailer Exclusive!<br /></span>'
    );

    headerDataTargets.forEach(target => {
      const trimmedTarget = target.trim();
      if (trimmedTarget === '') return;
      const escapedTarget = trimmedTarget.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escapedTarget})`, 'gi');
      currentHTML = currentHTML.replace(regex, '<span class="cursive-font">$1</span>');
    });
    navText.innerHTML = currentHTML;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('header, mobile-menu')) {
    updateNavItemFont();
  }
});


// Adjust product grid item height
function setHeight(parent) {
  const prodGridInfos = parent.querySelectorAll('.height-js-item');
  let maxHeight = 0;
  prodGridInfos.forEach(item => {
      item.style.height = 'auto';
      const itemHeight = item.offsetHeight;
      if (itemHeight > maxHeight) {
          maxHeight = itemHeight + 5;
      }
  });
  prodGridInfos.forEach(item => {
      item.style.height = `${maxHeight}px`;
  });
}
function checkAndSetHeight() {
    const parents = document.querySelectorAll('.height-js');
    parents.forEach(parent => {
      if (window.innerWidth > 768) {
          setHeight(parent);
      } else {
        if(parent.classList.contains('height-js-mobile-auto')) {
          parent.querySelectorAll('.height-js-item').forEach(item => item.style.height = 'auto');
        } else {
          setHeight(parent)
        }
      }
    })
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.height-js')) {
        checkAndSetHeight();
        window.addEventListener('resize', checkAndSetHeight);
    }
});


// Testimonials slider
const testimonalSlider = () => {
  const testimonialCarousel = document.querySelector('.testimonials-slider__slider');
  const tabContainer = document.querySelector('.slider-buttons');
  const flkty = new Flickity(testimonialCarousel, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      draggable: true,
      adaptiveHeight: true,
      groupCells: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            cellAlign: 'center',
            groupCells: 1
          }
        }
      ]
    });

  const tabs = document.querySelectorAll('.btn--testimonial-tab');

  function updateActiveTab(index) {
    tabs.forEach(tab => tab.classList.remove('is-selected'));
    if (tabs[index]) {
      tabs[index].classList.add('is-selected');
      scrollTabIntoView(tabs[index]);
    }
  }

  function scrollTabIntoView(activeTab) {
    if (!tabContainer || !activeTab) return;
    
    const containerRect = tabContainer.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
    
    const containerCenter = containerRect.width / 2;
    const tabCenter = tabRect.left - containerRect.left + (tabRect.width / 2);
    const scrollOffset = tabCenter - containerCenter;
    
    tabContainer.scrollTo({
      left: tabContainer.scrollLeft + scrollOffset,
      behavior: 'smooth'
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      const targetIndex = parseInt(this.dataset.loopIndex) - 1;
      flkty.select(targetIndex);
      updateActiveTab(targetIndex);
    });
  });

  flkty.on('change', function(index) {
    updateActiveTab(index);
  });

  updateActiveTab(0);
}
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.testimonials-slider')) {
      testimonalSlider();
    }
});
document.addEventListener('shopify:section:load', () => {
  if (document.querySelector('.testimonials-slider')) {
    testimonalSlider();
  }
});


// Updated smooth scroll
document.addEventListener('click', function(e) {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;
  
  e.preventDefault();
  const targetId = link.hash.slice(1);
  const target = document.getElementById(targetId);
  
  if (target) {
    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    const offset = link.classList.contains('collection-nav--link') ? 100 : 20;
    const targetPosition = rect.top + scrollTop - offset;
    
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }
});


// Product sibling slider and hover
const initializeSiblingsSlider = () => {
  const siblingsSlider = document.querySelector('.product-single fieldset.siblings');
  if (!siblingsSlider) return;
  
  const flkty = new Flickity(siblingsSlider, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    draggable: true,
    adaptiveHeight: true
  });

  const scrollToCurrentSlide = () => {
    const currentSlide = siblingsSlider.querySelector('.siblings__swatch[aria-current="true"]');
    if (currentSlide) {
      const slideIndex = Array.from(siblingsSlider.querySelectorAll('.siblings__swatch')).indexOf(currentSlide);
      if (slideIndex !== -1) {
        flkty.select(slideIndex, false, true);
      }
    }
  };

  const updateNavigationButtons = () => {
    const nextButton = document.querySelector('.product-single .siblings .flickity-button.next');
    const prevButton = document.querySelector('.product-single .siblings .flickity-button.previous');
    
    if (!nextButton || !prevButton) return;
    
    const currentIndex = flkty.selectedIndex;
    const totalSlides = flkty.slides.length;
    const slidesToShow = 6;
    const lastSelectableIndex = totalSlides - slidesToShow;
    
    nextButton.style.visibility = currentIndex >= lastSelectableIndex ? 'hidden' : 'visible';
    prevButton.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
  };

  const events = ['change', 'scroll', 'settle', 'dragEnd'];
  events.forEach(event => flkty.on(event, updateNavigationButtons));
  
  scrollToCurrentSlide();
  updateNavigationButtons();
};

const setupSiblingHoverInteractions = () => {
  const siblings = document.querySelectorAll('.siblings__swatch');
  const prodSiblingTitle = document.querySelector('.sibling-product-title .sibling-title');
  
  if (!prodSiblingTitle) return;
  
  siblings.forEach(sibling => {
    const siblingButton = sibling.querySelector('.siblings__button');
    if (!siblingButton) return;
    
    const siblingTitle = siblingButton.getAttribute('data-swatch');
    if (!siblingTitle) return;
    
    const handleMouseOver = () => {
      prodSiblingTitle.textContent = siblingTitle;
      prodSiblingTitle.classList.add('active');
    };

    const handleMouseOut = () => {
      prodSiblingTitle.classList.remove('active');
    };

    sibling.addEventListener('mouseover', handleMouseOver);
    sibling.addEventListener('mouseout', handleMouseOut);
  });
};

const prodSibling = () => {
  if (!document.querySelector('.product__block--siblings')) return;
  
  initializeSiblingsSlider();
  setupSiblingHoverInteractions();
};

document.addEventListener('DOMContentLoaded', prodSibling);
document.addEventListener('shopify:section:load', prodSibling);


// Product section subscriptions
const prodSubs = () => {
  const subTab = document.querySelector('.product__subs--tab-dropdown');
  const subDropdown = document.querySelector('.subscription-options__dropdown');
  const prodSubTabs = document.querySelectorAll('.product__subs--tab');
  const prodSubmitItem = document.querySelector('.product__submit__buttons');
  const sameDayBtn = document.querySelector('.btn--same-day-delivery');
  const sameDayModal = document.querySelector('.same-day-delivery-modal');
  const header = document.querySelector('.shopify-section-group-group-header.shopify-section-header');
  const announcement = document.querySelector('.shopify-section-group-group-header.announcement-bar-static');
  const modalCloseBtn = document.querySelector('.modal-close-btn');
  const modalContent = document.querySelector('.modal-content');
  const subOptions = document.querySelectorAll('.product_subs__option--name');
  const subPriceEl = document.querySelector('.product-single .product__price--regular--sub');
  const oneTimePriceEl = document.querySelector('.product-single .product__price--regular--one-time, [data-pdp-discount-wrapper]');
  const addTextOneTime = document.querySelector('.add-to-cart-text--one-time');
  const addTextSub = document.querySelector('.add-to-cart-text--sub');
  const quantityCounter = document.querySelector('.product-single quantity-counter[data-quantity-holder]');
  const quantityInput = quantityCounter.querySelector('.product-single [data-quantity-field]');
  const priceElement = document.querySelector('.add-to-cart-text--sub .product__price--regular');

  const productJson = JSON.parse(document.querySelector('[data-product-json]').textContent);
  const originalPrice = productJson.price;

  // Sale-collection override (Shopify collection ID 488318075105):
  // subscription-form.liquid emits data-collection-sale-sub-unit-price (cents)
  // only when the product is in that collection AND enable_price_discount is off.
  // When the attribute is absent we fall through to the existing 5% Auto-Renew calc.
  const collectionSaleSubWrap = document.querySelector('.product__subs__wrap[data-collection-sale-sub-unit-price]');
  const collectionSaleSubUnitPrice = collectionSaleSubWrap
    ? parseInt(collectionSaleSubWrap.dataset.collectionSaleSubUnitPrice, 10)
    : null;

  const handleQuantityChange = () => {
    const newQuantity = parseInt(quantityInput.value);

    let unitPrice;
    if (collectionSaleSubUnitPrice && !Number.isNaN(collectionSaleSubUnitPrice)) {
      unitPrice = collectionSaleSubUnitPrice;
    } else {
      unitPrice = Math.ceil(originalPrice * 0.95);
    }
    const totalPrice = unitPrice * newQuantity;

    const formattedPrice = `$${(totalPrice / 100).toFixed(2)}`;

    priceElement.textContent = formattedPrice;
  }

  quantityInput.addEventListener('input', handleQuantityChange);
  quantityInput.addEventListener('change', handleQuantityChange);

  handleQuantityChange();

  

  const closeModal = () => {
    sameDayModal.classList.remove('active');
    header.style.zIndex = '9000';
    announcement.style.zIndex = '9000';
    document.body.style.overflow = '';
  }

  const openModal = () => {
    sameDayModal.classList.add('active');
    header.style.zIndex = '0';
    announcement.style.zIndex = '0';
    document.body.style.overflow = 'hidden';
  }

  const isSameDayDelivery = (tab) => tab.classList.contains('product__subs--tab-same-day-delivery');

  subTab.addEventListener('click', () => {
    subDropdown.classList.toggle('expand-menu');
    subOptions.forEach(option => {
      if(option.innerHTML.includes('4 weeks')) {
        option.closest('.product__subs__option').click();
      }
    })
  });

  prodSubTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      if (!tab.classList.contains('product__subs--tab-dropdown') && subDropdown.classList.contains('expand-menu')) {
        subDropdown.classList.remove('expand-menu');
      }

      prodSubTabs.forEach(item => item.classList.remove('active'));
      tab.classList.add('active');

      if (isSameDayDelivery(tab)) {
        prodSubmitItem.classList.add('hidden');
        sameDayBtn.classList.remove('hidden');
      } else {
        prodSubmitItem.classList.remove('hidden');
        sameDayBtn.classList.add('hidden');
      }

      if(tab.classList.contains('product__subs--tab-dropdown')) {
        addTextSub.classList.remove('hidden');
        addTextOneTime.classList.add('hidden');

        subPriceEl.classList.remove('hidden');
        oneTimePriceEl.classList.add('hidden');        
      } else if(tab.classList.contains('product__subs--tab-one-time')) {
        addTextSub.classList.add('hidden');
        addTextOneTime.classList.remove('hidden');

        subPriceEl.classList.add('hidden');
        oneTimePriceEl.classList.remove('hidden'); 
      }

    });
  });

  //sameDayBtn.addEventListener('click', openModal);
  modalCloseBtn.addEventListener('click', closeModal);

  //sameDayModal.addEventListener('click', (e) => {
    //if (!modalContent.contains(e.target)) closeModal();
  //});

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sameDayModal.classList.contains('active')) {
      closeModal();
    }
  });
}

// Accessibility: expose the One-Time / Auto-Renew / Same Day Delivery tabs as
// a single ARIA radio group with roving tabindex and arrow-key support, so
// screen reader and keyboard users perceive and operate them as radio buttons.
// Visuals are untouched: selection re-uses the existing pointer-click handlers
// (which toggle `.active` and drive the underlying selling-plan logic).
const subsTabsA11y = () => {
  const groups = document.querySelectorAll('.product__subs--tabs');
  if (!groups.length) return;

  groups.forEach((group) => enhanceSubsTabGroup(group));
};

// Wire one purchase-option group as an accessible ARIA radio group.
const enhanceSubsTabGroup = (group) => {
  const tabs = Array.from(group.querySelectorAll('.product__subs--tab'));
  if (!tabs.length) return;

  const syncState = () => {
    let activeIndex = tabs.findIndex((tab) => tab.classList.contains('active'));
    if (activeIndex === -1) activeIndex = 0;
    tabs.forEach((tab, i) => {
      const isChecked = i === activeIndex;
      tab.setAttribute('aria-checked', isChecked ? 'true' : 'false');
      tab.setAttribute('tabindex', isChecked ? '0' : '-1');
    });
  };

  const selectTab = (tab) => {
    tab.focus();
    if (!tab.classList.contains('active')) {
      // Mimic a pointer click on the visible tab so every existing handler
      // (active state, price/button swap, dropdown expand) runs unchanged.
      const trigger = tab.querySelector('.product__subs--label') || tab;
      trigger.click();
    }
    syncState();
  };

  group.addEventListener('keydown', (e) => {
    const currentIndex = tabs.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    let nextIndex = null;
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        break;
      case ' ':
      case 'Enter':
        e.preventDefault();
        selectTab(tabs[currentIndex]);
        return;
      default:
        return;
    }

    e.preventDefault();
    selectTab(tabs[nextIndex]);
  });

  // Keep ARIA state in sync when a tab is chosen with a pointer.
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => window.requestAnimationFrame(syncState));
  });

  syncState();
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.product__subs__wrap')) {
    prodSubs();
    subsTabsA11y();
  }
});


// Product details
const prodDetailsTexture = () => {
  const prodDetails = document.querySelector('.product-details');

  if(!prodDetails) return;

  const positionTextureArrow = () => {
    const textureBar = document.querySelector('.texture-dist-bar');
    const arrow = textureBar?.querySelector('svg');
    const textureContainer = document.querySelector('.textures');
    
    if (!arrow || !textureBar || !textureContainer) return;
    
    const currentTexture = textureBar.dataset.texture;
    
    const textureMap = {
      'soft': 0,
      'soft-chewy': [0, 1],
      'chewy': 1,
      'chewy-crunchy': [1, 2],
      'crunchy': 2,
      'crunchy-hard': [2, 3],
      'hard': 3
    };
    
    const titles = textureContainer.querySelectorAll('.texture-title');
    const target = textureMap[currentTexture];
    
    if (!target && target !== 0) return;
    
    let targetPosition;
    
    const barRect = textureBar.getBoundingClientRect();
    
    if (Array.isArray(target)) {
      const leftEl = titles[target[0]];
      const rightEl = titles[target[1]];
      const leftRect = leftEl.getBoundingClientRect();
      const rightRect = rightEl.getBoundingClientRect();
      
      const leftCenter = leftRect.left + (leftRect.width / 2);
      const rightCenter = rightRect.left + (rightRect.width / 2);
      const absoluteCenter = (leftCenter + rightCenter) / 2;
      
      targetPosition = absoluteCenter - barRect.left;
    } else {
      const targetEl = titles[target];
      const targetRect = targetEl.getBoundingClientRect();
      const absoluteCenter = targetRect.left + (targetRect.width / 2);
      
      targetPosition = absoluteCenter - barRect.left;
    }
    
    arrow.style.left = `${targetPosition}px`;
    arrow.style.transform = 'translateX(-50%)';
  }

  window.addEventListener('load', positionTextureArrow);
  window.addEventListener('resize', positionTextureArrow);
};
document.addEventListener("DOMContentLoaded", prodDetailsTexture);
document.addEventListener('shopify:section:load', prodDetailsTexture);


// Blog filter slider
const blogFilterSlider = () => {
  const blogFilters = document.querySelector('.blog .blog__tags-list-custom');
  const flkty = new Flickity(blogFilters, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      draggable: true,
      adaptiveHeight: true,
      prevNextButtons: false
    });
}
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.blog .blog__tags-list-custom')) {
      blogFilterSlider();
    }
});
document.addEventListener('shopify:section:load', () => {
  if (document.querySelector('.blog .blog__tags-list-custom')) {
    blogFilterSlider();
  }
});


// news + press header color update
const newsPressHeaderColor = () => {
  const header = document.querySelector('.site-header');
  if(!header?.classList.contains('site-header--reverse-color')) return;
  header.classList.remove('site-header--transparent');
  header.addEventListener('mouseover', () => {
    header.classList.add('site-header--transparent');
  })
  header.addEventListener('mouseout', () => {
    header.classList.remove('site-header--transparent');
  })
}
document.addEventListener("DOMContentLoaded", newsPressHeaderColor);
document.addEventListener('shopify:section:load', newsPressHeaderColor);


// Rewards page header
const rewardsHeader = () => {
  const body = document.querySelector('body');
  const header = document.querySelector('.site-header');
  if(!body?.classList.contains('rewards-customer--logged-out')) return;
  header.style.position = 'relative';
  header.classList.remove('site-header--transparent');
  header.addEventListener('mouseover', () => {
    header.classList.add('site-header--transparent');
  })
  header.addEventListener('mouseout', () => {
    header.classList.remove('site-header--transparent');
  })
}
document.addEventListener("DOMContentLoaded", rewardsHeader);
document.addEventListener('shopify:section:load', rewardsHeader);


// Trigger Attentive popup


// Get the button element
const signupButton = document.getElementById('signup-trigger');

// Add a click event listener
signupButton.addEventListener('click', () => {
  // Call the Attentive trigger function when the button is clicked
  if(window.innerWidth >= 760){

  //call the desktop creative

  window.__attentive.trigger(null,null,null,1144752)

  } else {

  //call the mobile creative

  window.__attentive.trigger(null,null,null, 1144740)

  }


});



  setTimeout( () => window.__attentive.trigger(), 1500);